(function () {
  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  function esc(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function t(key) {
    return (window.USHARE_HPD_I18N || {})[key] || "";
  }

  function pageOverride() {
    var out = { handle: "", title: "", html: "", hasHtml: false };
    var el = document.getElementById("ushare-page-override");
    if (el) {
      try {
        var parsed = JSON.parse(el.textContent || "{}");
        out.handle = parsed.handle || "";
        out.title = parsed.title || "";
        out.html = parsed.html || "";
        out.hasHtml = Boolean(parsed.hasHtml);
      } catch (e) {}
    }
    var tpl = document.getElementById("ushare-page-html");
    if (tpl) {
      var html = (tpl.innerHTML || "").trim();
      if (html) {
        out.html = html;
        out.hasHtml = true;
      }
    }
    if (document.querySelector("[data-has-html]")) out.hasHtml = true;
    return out;
  }

  function textOf(node) {
    return String((node && node.textContent) || "").replace(/\s+/g, " ").trim();
  }

  function sectionKind(text) {
    var s = String(text || "").replace(/\s+/g, " ").trim();
    if (/^overview$|^hospital overview$|^介绍$|^医院介绍$|^resumen$|^présentation$|^überblick$|^обзор$|^نظرة عامة$|^ikhtisar$/i.test(s)) return "overview";
    if (/^why\b|^why choose|^为什么|^por qué|^pourquoi|^warum|^почему|^لماذا|^mengapa/i.test(s)) return "why";
    if (/^capabilities$|^complex cases$|^诊疗能力$|^能力$|^capacidades$|^capacités$|^leistungen$|^возможности$|^القدرات$|^kapabilitas$/i.test(s)) return "capabilities";
    if (/^equipment$|^设备$|^equipamiento$|^équipement$|^ausstattung$|^оборудование$|^المعدات$|^peralatan$/i.test(s)) return "equipment";
    if (/^faqs?$|^frequently asked questions?$|常见问题|preguntas frecuentes|questions fréquentes|häufige fragen|часто задаваемые|الأسئلة الشائعة|pertanyaan umum/i.test(s)) return "faq";
    return "";
  }

  function nodesFromHtml(html) {
    var wrap = document.createElement("div");
    wrap.innerHTML = html || "";
    return Array.prototype.slice.call(wrap.childNodes);
  }

  function parseFaqs(nodes) {
    var faqs = [];
    var q = "";
    var answers = [];
    function flush() {
      if (!q) return;
      faqs.push({ q: q, a: answers.join("\n\n") });
      q = "";
      answers = [];
    }
    nodes.forEach(function (node) {
      if (!node || node.nodeType !== 1) {
        var stray = textOf(node);
        if (q && stray) answers.push(stray);
        return;
      }
      var heading = /^H[1-4]$/.test(node.nodeName);
      if (heading) {
        flush();
        q = textOf(node);
        return;
      }
      var line = textOf(node);
      if (!line) return;
      if (!q) q = line;
      else answers.push(line);
    });
    flush();
    return faqs.filter(function (item) { return item.q; });
  }

  function parseEquipment(nodes) {
    var eq = [];
    var n = "";
    var d = [];
    function flush() {
      if (!n) return;
      eq.push({ n: n, d: d.join(" ") });
      n = "";
      d = [];
    }
    nodes.forEach(function (node) {
      if (!node || node.nodeType !== 1) return;
      if (/^H[1-4]$/.test(node.nodeName)) {
        flush();
        n = textOf(node);
        return;
      }
      var line = textOf(node);
      if (!line) return;
      if (!n) n = line;
      else d.push(line);
    });
    flush();
    return eq.filter(function (item) { return item.n; });
  }

  function parsePageSections(html) {
    var source = html || "";
    var headingRe =
      /<(h[1-4]|p)(\s[^>]*)?>\s*(?:<(?:strong|b|span|em)[^>]*>\s*)*(Overview|Hospital Overview|介绍|医院介绍|Resumen|Présentation|Überblick|Обзор|نظرة عامة|Ikhtisar|Why(?:\s+choose[^<]*)?|为什么[^<]*|Por qué[^<]*|Pourquoi[^<]*|Warum[^<]*|Почему[^<]*|لماذا[^<]*|Mengapa[^<]*|Capabilities|Complex cases|诊疗能力|Capacidades|Capacités|Leistungen|Возможности|القدرات|Kapabilitas|Equipment|设备|Equipamiento|Équipement|Ausstattung|Оборудование|المعدات|Peralatan|FAQs?|Frequently Asked Questions|常见问题|Preguntas frecuentes|Questions fréquentes|Häufige Fragen|Часто задаваемые вопросы|الأسئلة الشائعة|Pertanyaan umum)(?:\s*<\/(?:strong|b|span|em)>)*\s*<\/\1>/gi;
    var found = [];
    var match;
    while ((match = headingRe.exec(source))) {
      found.push({
        kind: sectionKind(match[3]),
        start: match.index,
        end: match.index + match[0].length
      });
    }
    var articleHtml = found.length ? source.slice(0, found[0].start) : source;
    var buckets = { overview: "", why: "", capabilities: "", equipment: "", faq: "" };
    var seen = { overview: false, why: false, capabilities: false, equipment: false, faq: false };
    found.forEach(function (sec, i) {
      if (!sec.kind) return;
      seen[sec.kind] = true;
      var until = i + 1 < found.length ? found[i + 1].start : source.length;
      buckets[sec.kind] += source.slice(sec.end, until);
    });
    if (!seen.overview && articleHtml.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim()) {
      buckets.overview = articleHtml;
      seen.overview = true;
    }
    return {
      overviewHtml: buckets.overview.trim(),
      hasOverview: seen.overview,
      why: textOf({ textContent: buckets.why.replace(/<[^>]+>/g, " ") }),
      hasWhy: seen.why,
      cap: textOf({ textContent: buckets.capabilities.replace(/<[^>]+>/g, " ") }),
      hasCap: seen.capabilities,
      eq: parseEquipment(nodesFromHtml(buckets.equipment)),
      hasEq: seen.equipment,
      faqs: parseFaqs(nodesFromHtml(buckets.faq)),
      hasFaq: seen.faq
    };
  }

  function catalogBySlug(s) {
    return (window.USHARE_HOSPITALS || []).filter(function (h) {
      return h.s === s;
    })[0];
  }

  function deptName(code) {
    var maps = [
      (window.USHARE_HP_COPY || {}).depts,
      (window.USHARE_HPD_I18N || {}).deptMap
    ];
    for (var i = 0; i < maps.length; i++) {
      if (maps[i] && maps[i][code]) return maps[i][code];
    }
    return String(code || "")
      .replace(/_/g, " ")
      .replace(/\b\w/g, function (c) {
        return c.toUpperCase();
      });
  }

  function label(mapKey, code) {
    var map = (window.USHARE_HPD_I18N || {})[mapKey] || {};
    if (map[code]) return map[code];
    return String(code || "")
      .replace(/_/g, " ")
      .replace(/\b\w/g, function (c) {
        return c.toUpperCase();
      });
  }

  function num(n) {
    var x = Number(n);
    if (!isFinite(x)) return "";
    return x.toLocaleString("en-US");
  }

  function pinSvg() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 21s7-5.4 7-11a7 7 0 1 0-14 0c0 5.6 7 11 7 11z"/><circle cx="12" cy="10" r="2.4"/></svg>';
  }

  function stethSvg() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 4v7a4 4 0 0 0 8 0V4"/><path d="M6 4H4m10 0h2"/><circle cx="18" cy="16" r="3"/><path d="M18 13a7 7 0 0 1-7 7H9"/></svg>';
  }

  function shieldSvg() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 3 5 6v6c0 5 3.2 8.2 7 9.5C15.8 20.2 19 17 19 12V6l-7-3z"/><path d="m9 12 2 2 4-4"/></svg>';
  }

  function chevron() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m6 9 6 6 6-6"/></svg>';
  }

  function chips(items, mapKey) {
    if (!items || !items.length) return "";
    return (
      '<div class="ushare-hpd-chips">' +
      items
        .map(function (code) {
          return '<span class="ushare-hpd-chip">' + esc(label(mapKey, code)) + "</span>";
        })
        .join("") +
      "</div>"
    );
  }

  var LANG_CODES = {
    en: 1,
    zh: 1,
    jp: 1,
    ru: 1,
    fr: 1,
    de: 1,
    es: 1,
    ar: 1,
    kr: 1,
    th: 1,
    yue: 1
  };
  var FUP_CODES = {
    lifetime: 1,
    "1_year": 1,
    "6_months": 1,
    telemedicine: 1,
    local_partner: 1
  };

  function splitServices(item) {
    var intl = [];
    var langs = [];
    var fup = [];
    var seen = {};
    function add(code, bucket) {
      var key = String(code || "");
      if (!key || seen[key]) return;
      seen[key] = 1;
      bucket.push(key);
    }
    (item.intl || [])
      .concat(item.langs || [])
      .concat(item.fup || [])
      .forEach(function (code) {
        if (LANG_CODES[code]) add(code, langs);
        else if (FUP_CODES[code]) add(code, fup);
        else add(code, intl);
      });
    return { intl: intl, langs: langs, fup: fup };
  }

  ready(function () {
    if (typeof window.ushareApplyI18n === "function") window.ushareApplyI18n();
    var root = document.querySelector("[data-ushare-hpd]");
    if (!root) return;
    var slug = root.getAttribute("data-slug") || "";
    var items = window.USHARE_HPD || [];
    var page = pageOverride();
    var listed = catalogBySlug(slug);
    var item = items.filter(function (x) {
      return x.s === slug;
    })[0];
    if (item) {
      if (page.title) item.n = page.title;
      if (page.hasHtml) {
        var parts = parsePageSections(page.html || "");
        if (parts.hasOverview) {
          item.ovHtml = parts.overviewHtml;
          item.ov = "";
        }
        if (parts.hasWhy) item.why = parts.why;
        if (parts.hasCap) item.cap = parts.cap;
        if (parts.hasEq) item.eq = parts.eq;
        if (parts.hasFaq) item.pageFaqs = parts.faqs;
      }
    } else if (page.title || page.hasHtml || listed) {
      item = {
        s: slug,
        n: page.title || (listed && listed.n) || "",
        ov: "",
        ovHtml: "",
        loc: (listed && listed.loc) || "",
        specs: [],
      };
      if (page.hasHtml) {
        var fresh = parsePageSections(page.html || "");
        if (fresh.hasOverview) item.ovHtml = fresh.overviewHtml;
        if (fresh.hasWhy) item.why = fresh.why;
        if (fresh.hasCap) item.cap = fresh.cap;
        if (fresh.hasEq) item.eq = fresh.eq;
        if (fresh.hasFaq) item.pageFaqs = fresh.faqs;
      }
    }
    if (item && listed) {
      if (listed.n) item.n = item.n || listed.n;
      if (listed.loc) item.loc = listed.loc;
      if (listed.i) item.i = listed.i;
      if (listed.tier) item.tier = listed.tier;
      else if (listed.t && !item.tier) item.tier = "Tertiary";
      if (listed.ht) item.ht = listed.ht;
      if (listed.p) item.own = "Private";
      else item.own = "Public";
      if (listed.beds !== "" && listed.beds != null) item.beds = listed.beds;
      if (listed.staff !== "" && listed.staff != null) item.staff = listed.staff;
      if (listed.addr) item.addr = listed.addr;
      if (Array.isArray(listed.intl)) item.intl = listed.intl;
      item.langs = Array.isArray(listed.langs) ? listed.langs : [];
      item.fup = Array.isArray(listed.fup) ? listed.fup : [];
      if (listed.depts && listed.depts.length) {
        item.specs = listed.depts.map(function (code) {
          return { n: deptName(code), d: "" };
        });
      }
    }
    var mount = root.querySelector("[data-hpd-root]");
    if (!item) {
      mount.innerHTML =
        '<div class="ushare-hpd-missing"><p>' +
        esc(t("missing")) +
        '</p><p><a href="' +
        (window.ushareUrl || String)("/hospitals") +
        '">' +
        esc(t("back")) +
        "</a></p></div>";
      return;
    }

    document.title = item.n + " – Ushare";

    var listing = listed && listed.img ? listed.img : (window.USHARE_HP_IMGS || {})[item.i] || "";
    var heroes = window.USHARE_HPD_HERO || {};
    var extras = (window.USHARE_HPD_G || {})[item.i] || {};
    var heroSrc = item.hero && heroes[item.i] ? heroes[item.i] : listing;
    var photos = [];
    if (listed && listed.photos && listed.photos.length) {
      photos = listed.photos.filter(Boolean);
    } else {
      (item.g || []).forEach(function (n) {
        if (extras[String(n)]) photos.push(extras[String(n)]);
      });
    }
    if (!photos.length && listing) photos = [listing];
    if (!photos.length && heroSrc) photos = [heroSrc];

    var seen = {};
    photos = photos.filter(function (src) {
      if (!src || seen[src]) return false;
      seen[src] = 1;
      return true;
    });

    var stageSrc = photos[0] || listing;
    var thumbs =
      photos.length > 1
        ? '<div class="ushare-hpd-thumbs">' +
          photos
            .map(function (src, i) {
              return (
                '<button type="button" data-photo="' +
                i +
                '" class="' +
                (i === 0 ? "is-active" : "") +
                '"><img src="' +
                esc(src) +
                '" alt=""></button>'
              );
            })
            .join("") +
          "</div>"
        : "";
    var arrows =
      photos.length > 1
        ? '<button class="ushare-hpd-nav ushare-hpd-nav--prev" type="button" data-dir="-1" aria-label="' +
          esc(t("prev")) +
          '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 6l-6 6 6 6"/></svg></button>' +
          '<button class="ushare-hpd-nav ushare-hpd-nav--next" type="button" data-dir="1" aria-label="' +
          esc(t("next")) +
          '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 6l6 6-6 6"/></svg></button>'
        : "";

    var badges = '<div class="ushare-hpd-badges">';
    if (item.tier) badges += '<span class="ushare-hpd-badge ushare-hpd-badge--tier">' + esc(item.tier) + "</span>";
    if (item.ht) badges += '<span class="ushare-hpd-badge ushare-hpd-badge--type">' + esc(item.ht) + "</span>";
    badges += "</div>";

    var why = item.why
      ? '<div class="ushare-hpd-why"><h3>' + esc(t("why")) + "</h3><p>" + esc(item.why) + "</p></div>"
      : "";
    var stat = item.visits
      ? '<p class="ushare-hpd-stat"><strong>' + num(item.visits) + "</strong><span>" + esc(t("visits")) + "</span></p>"
      : "";

    var cap = item.cap
      ? '<section><h2>' +
        esc(t("capabilities")) +
        '</h2><p class="ushare-hpd-lead">' +
        esc(t("cap_lead")) +
        '</p><article class="ushare-hpd-cap">' +
        shieldSvg() +
        "<div><h3>" +
        esc(t("complex")) +
        "</h3><p>" +
        esc(item.cap) +
        "</p></div></article></section>"
      : "";

    var eqHtml = "";
    if (item.eq && item.eq.length) {
      eqHtml =
        "<section><h2>" +
        esc(t("equipment")) +
        '</h2><div class="ushare-hpd-eq">' +
        item.eq
          .map(function (e) {
            return (
              '<article class="ushare-hpd-eq-card"><h3>' +
              esc(e.n) +
              "</h3>" +
              (e.d ? "<p>" + esc(e.d) + "</p>" : "") +
              "</article>"
            );
          })
          .join("") +
        "</div></section>";
    }

    var faqs = item.pageFaqs && item.pageFaqs.length
      ? item.pageFaqs
      : [
          { q: t("faq_1_q"), a: t("faq_1_a") },
          { q: t("faq_2_q"), a: t("faq_2_a") },
          { q: t("faq_3_q"), a: t("faq_3_a") },
          { q: t("faq_4_q"), a: t("faq_4_a") }
        ];
    var faqHtml =
      '<section class="ushare-hpd-faq"><h2>' +
      esc(t("faq")) +
      '</h2><p class="ushare-hpd-lead">' +
      esc(t("faq_lead")) +
      "</p>";
    faqs.forEach(function (faq) {
      faqHtml +=
        '<div class="ushare-hpd-acc"><button type="button">' +
        esc(faq.q) +
        chevron() +
        '</button><div class="ushare-hpd-acc__body">' +
        (faq.a ? "<p>" + esc(faq.a) + "</p>" : "") +
        "</div></div>";
    });
    faqHtml += "</section>";

    var infoRows = "";
    infoRows +=
      "<div><dt>" +
      esc(t("tier")) +
      "</dt><dd>" +
      esc(item.tier || t("unavailable")) +
      "</dd></div>";
    if (item.own)
      infoRows += "<div><dt>" + esc(t("ownership")) + "</dt><dd>" + esc(item.own) + "</dd></div>";
    if (item.beds)
      infoRows += "<div><dt>" + esc(t("beds")) + "</dt><dd>" + esc(String(item.beds)) + "</dd></div>";
    if (item.staff)
      infoRows += "<div><dt>" + esc(t("staff")) + "</dt><dd>" + esc(String(item.staff)) + "</dd></div>";

    var maps = item.addr
      ? '<a class="ushare-hpd-maps" href="https://www.google.com/maps/search/?api=1&query=' +
        encodeURIComponent(item.addr) +
        '" target="_blank" rel="noopener">' +
        pinSvg() +
        esc(t("maps")) +
        "</a>"
      : "";

    var specs = (item.specs || [])
      .map(function (s) {
        var tip = s.d ? ' data-tip="' + esc(s.d) + '"' : "";
        return '<div class="ushare-hpd-spec"' + tip + ">" + stethSvg() + "<span>" + esc(s.n) + "</span></div>";
      })
      .join("");

    var svc = splitServices(item);
    var intl = "";
    if (svc.intl.length || svc.langs.length || svc.fup.length) {
      intl =
        '<div class="ushare-hpd-card"><h3>' +
        esc(t("intl")) +
        "</h3>" +
        chips(svc.intl, "intlMap") +
        (svc.langs.length
          ? '<p class="ushare-hpd-sub">' + esc(t("languages")) + "</p>" + chips(svc.langs, "langMap")
          : "") +
        (svc.fup.length
          ? '<p class="ushare-hpd-sub">' + esc(t("followup")) + "</p>" + chips(svc.fup, "fupMap")
          : "") +
        "</div>";
    }

    mount.innerHTML =
      '<section class="ushare-hpd-hero"><div class="ushare-hpd-hero__media"><img src="' +
      esc(heroSrc || listing) +
      '" alt="' +
      esc(item.n) +
      '"></div><div class="ushare-hpd-hero__fade"></div><div class="ushare-hpd-hero__inner"><div>' +
      badges +
      "<h1>" +
      esc(item.n) +
      "</h1>" +
      (item.loc ? '<p class="ushare-hpd-hero__loc">' + esc(item.loc) + "</p>" : "") +
      "</div></div></section>" +
      '<div class="ushare-hpd-body"><div class="ushare-hpd-main"><section class="ushare-hpd-photos"><h2>' +
      esc(t("photos")) +
      '</h2><div class="ushare-hpd-stage"><img data-stage src="' +
      esc(stageSrc) +
      '" alt="' +
      esc(item.n) +
      '">' +
      arrows +
      "</div>" +
      thumbs +
      '</section><section class="ushare-hpd-overview"><h2>' +
      esc(t("overview")) +
      "</h2>" +
      (item.ovHtml ? '<div class="ushare-hpd-ov-html">' + item.ovHtml + "</div>" : "<p>" + esc(item.ov) + "</p>") +
      why +
      stat +
      "</section>" +
      cap +
      eqHtml +
      faqHtml +
      '</div><aside class="ushare-hpd-side"><div class="ushare-hpd-card"><h3>' +
      esc(t("info")) +
      '</h3><dl class="ushare-hpd-dl">' +
      infoRows +
      "</dl>" +
      (item.addr ? '<p class="ushare-hpd-addr">' + pinSvg() + esc(item.addr) + "</p>" : "") +
      maps +
      "</div>" +
      (specs
        ? '<div class="ushare-hpd-card"><h3>' +
          esc(t("specialties")) +
          " <span>" +
          (item.specs || []).length +
          "</span></h3>" +
          ((item.specs || []).some(function (s) { return s.d; })
            ? '<p class="ushare-hpd-hint">' + esc(t("spec_hint")) + "</p>"
            : "") +
          '<div class="ushare-hpd-specs">' +
          specs +
          "</div></div>"
        : "") +
      intl +
      '<a class="ushare-hpd-quote" href="' +
      (window.ushareUrl || String)(
        "/free-quote?hospital=" +
          encodeURIComponent(item.n || "") +
          (item.loc ? "&city=" + encodeURIComponent(String(item.loc).split(",")[0].trim()) : "")
      ) +
      '">' +
      esc(t("quote")) +
      "</a></aside></div>";

    var photoIndex = 0;
    function showPhoto(i) {
      if (!photos.length) return;
      photoIndex = (i + photos.length) % photos.length;
      var img = mount.querySelector("[data-stage]");
      if (img) img.src = photos[photoIndex];
      mount.querySelectorAll("[data-photo]").forEach(function (btn) {
        btn.classList.toggle("is-active", Number(btn.getAttribute("data-photo")) === photoIndex);
      });
    }

    mount.addEventListener("click", function (e) {
      var accBtn = e.target.closest(".ushare-hpd-acc button");
      if (accBtn) {
        var acc = accBtn.parentElement;
        var open = acc.classList.contains("is-open");
        mount.querySelectorAll(".ushare-hpd-acc").forEach(function (el) {
          el.classList.remove("is-open");
        });
        if (!open) acc.classList.add("is-open");
        return;
      }
      var thumb = e.target.closest("[data-photo]");
      if (thumb) {
        showPhoto(Number(thumb.getAttribute("data-photo")));
        return;
      }
      var nav = e.target.closest("[data-dir]");
      if (nav) showPhoto(photoIndex + Number(nav.getAttribute("data-dir")));
    });
  });
})();
